import { create } from "zustand";

export const useNotifyCount=create((set)=>({
    notifyCount: 0,
    setNotifyCount:(notifyCount)=>set({notifyCount}),
    decreaseNotifyCount  :()=>set((state)=>({
        notifyCount: state.notifyCount > 0 ? state.notifyCount - 1 : 0
    })),
    increaseNotifyCount  :()=>set((state)=>({
        notifyCount: state.notifyCount + 1
    })),
    removeAllNotifyCount:()=>set({notifyCount:0})
}))